import React, { useContext, useState } from "react";
import {
  Modal,
  Box,
  IconButton,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
  Typography,
} from "@mui/material";
import { useQuery } from "react-query";
import { Close, Schedule } from "@mui/icons-material";
import MyContext from "../../context/MyContext";
import { getSubLocations } from "../../api/services/scheduling";
import CustomDate from "../CustomForm/CustomDate";
import { formatLondonDate } from "../../utils/time";

const ShowScheduleModal = ({
  show,
  handleClose,
  setDate,
  setSelectedSublocation,
}) => {
  const [selectedDate, setSelectedDate] = useState(
    formatLondonDate(new Date(), "yyyy-MM-dd")
  );
  const { locationID } = useContext(MyContext);

  const { data: subLocations, isLoading } = useQuery(
    ["subLocations", locationID, selectedDate],
    () => getSubLocations(locationID, selectedDate),
    { enabled: !!locationID || !!selectedDate }
  );

  const handleShowSchedule = (sublocation) => {
    setDate(selectedDate);
    setSelectedSublocation(sublocation.id);
    handleClose();
  };

  return (
    <Modal open={show} onClose={handleClose}>
      <Box
        sx={{
          maxWidth: 500,
          width: "90%",
          mx: "auto",
          mt: { xs: 4, sm: 6 },
          maxHeight: "85vh",
          p: { xs: 2, sm: 3 },
          backgroundColor: "white",
          borderRadius: 2,
          position: "relative",
          display: "flex",
          flexDirection: "column",
          outline: "none",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
            flexShrink: 0,
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            Show Schedule
          </Typography>
          <IconButton onClick={handleClose} color="error" size="small">
            <Close />
          </IconButton>
        </Box>

        <Box sx={{ flexShrink: 0, mb: 2 }}>
          <CustomDate
            label="Select Date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            border: "1px solid #ddd",
            borderRadius: "8px",
            minHeight: 120,
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::-webkit-scrollbar": {
              width: 0,
              height: 0,
            },
          }}
        >
          {isLoading ? (
            <ListItem>
              <ListItemText
                primary="Loading..."
                sx={{ textAlign: "center", color: "gray" }}
              />
            </ListItem>
          ) : subLocations?.length > 0 ? (
            <List disablePadding>
              {subLocations.map((sublocation, index) => (
                <React.Fragment key={sublocation.id}>
                  <ListItem
                    sx={{
                      padding: "10px 16px",
                      "&:hover": { backgroundColor: "#f5f5f5" },
                      flexWrap: { xs: "wrap", sm: "nowrap" },
                      gap: 1,
                    }}
                    secondaryAction={
                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        startIcon={<Schedule />}
                        onClick={() => handleShowSchedule(sublocation)}
                        sx={{ whiteSpace: "nowrap" }}
                      >
                        Show
                      </Button>
                    }
                  >
                    <ListItemText
                      primary={sublocation.name}
                      primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }}
                      sx={{ pr: { xs: 0, sm: 14 } }}
                    />
                  </ListItem>
                  {index < subLocations.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>
          ) : (
            <ListItem>
              <ListItemText
                primary="No sub-locations found."
                sx={{ textAlign: "center", color: "gray" }}
              />
            </ListItem>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: 3,
            flexShrink: 0,
          }}
        >
          <Button onClick={handleClose} variant="contained" color="error">
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ShowScheduleModal;